import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { api } from "../lib/api";

const timeAgo = (iso) => {
  const mins = Math.max(1, Math.round((Date.now() - new Date(iso)) / 60000));
  if (mins < 60) return `${mins}m ago`;
  const h = Math.round(mins / 60);
  if (h < 24) return `${h}h ago`;
  return `${Math.round(h / 24)}d ago`;
};

export const SoldTicker = () => {
  const [claims, setClaims] = useState([]);
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    const load = () => api.get("/claims/recent").then(({ data }) => setClaims(data)).catch(() => {});
    load();
    const poll = setInterval(load, 30000);
    return () => clearInterval(poll);
  }, []);

  useEffect(() => {
    if (claims.length < 2) return;
    const t = setInterval(() => setIdx((i) => (i + 1) % claims.length), 4000);
    return () => clearInterval(t);
  }, [claims.length]);

  if (claims.length === 0) return null;
  const c = claims[idx];

  return (
    <div data-testid="sold-ticker" className="border-b border-[#27272A] bg-[#111111] overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 h-11 flex items-center gap-3">
        <span className="w-2 h-2 bg-[#FF3B30] animate-pulse shrink-0" />
        <span className="text-[10px] uppercase tracking-widest text-white/40 shrink-0">Just claimed</span>
        <div className="relative flex-1 h-full overflow-hidden">
          <AnimatePresence mode="wait">
            <motion.div
              key={idx}
              initial={{ y: 16, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              exit={{ y: -16, opacity: 0 }}
              transition={{ duration: 0.35, ease: [0.16, 1, 0.3, 1] }}
              className="absolute inset-0 flex items-center text-xs sm:text-sm text-white/80 truncate"
            >
              <span className="text-[#FFCC00] mr-2">{c.buyer}</span> claimed {c.qty}x {c.title}
              <span className="text-white/30 ml-2">· {timeAgo(c.at)}</span>
            </motion.div>
          </AnimatePresence>
        </div>
      </div>
    </div>
  );
};
